module.exports = "/static/assets/df78b6007d44f12f02b0eda0d4ab2819.png";